import { Component, OnInit, Input } from '@angular/core';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

@Component({
	selector: 'app-stats',
	templateUrl: './stats.component.html',
	styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit {

	@Input() stats;

	constructor(
		public detectDevice: DetectDeviceService
	) { }

	ngOnInit(): void {
	}

}
